import { z } from 'zod';

/**
 * テスト実施 対象テスト条件 選択画面の URL search スキーマ。
 *
 * - freeText:        テストセット名 / 条件タイトルの部分一致検索
 * - page / pageSize: ページネーション
 *
 * 進捗ステータス（NOT_STARTED / IN_PROGRESS / COMPLETED）は候補が少数想定の
 * MVP のため、専用フィルタチップは設けずグリッドの列バッジで提示する。
 */
export const conditionTargetsSearchSchema = z.object({
  page: z.coerce.number().min(1).optional().default(1),
  pageSize: z.coerce.number().min(1).optional().default(100),
  freeText: z.string().optional()
});
export type ConditionTargetsSearch = z.infer<typeof conditionTargetsSearchSchema>;